export enum AppFeature {
  // main features
  Graphs = 'graphs',
  Inspections = 'inspections',
  Research = 'research',
  ReferenceTables = 'reference_tables',
  Settings = 'settings',
  // sub features
  GraphsInspections = 'graphs_inspections',
  InspectionsFids = 'inspections_fids',
  InspectionsSharks = 'inspections_sharks',
  InspectionsScale = 'inspections_scale',
  ResearchBiologicalSampling = 'research_biological_sampling',
  ReferenceTablesShipOwners = 'reference_tables_ship_owners',
  ReferenceTablesBiologists = 'reference_tables_biologists',
  ReferenceTablesCaptains = 'reference_tables_captains',
  ReferenceTablesInspectors = 'reference_tables_inspectors',
  ReferenceTablesCoastGuards = 'reference_tables_coast_guards',
  ReferenceTablesShips = 'reference_tables_ships',
  ReferenceTablesSpecies = 'reference_tables_species',
  ReferenceTablesDocks = 'reference_tables_docks',
  ReferenceTablesPorts = 'reference_tables_ports',
  SettingsUsers = 'settings_users',
  SettingsRoles = 'settings_roles',
  SettingsPermissions = 'settings_permissions',
}

export enum AppActions {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  DownloadCsv = 'downloadCsv',
  DownloadPdf = 'downloadPdf',
}

export enum AppScope {
  Platform = 'platform', // app name
}

/**
 * Creates a string claim based on app feature and app action.
 * @param feature
 * @param action
 * @returns
 */
export function getClaimString(
  feature: AppFeature,
  action: AppActions
): string {
  return `${AppScope.Platform}:${feature}:${action}`;
}
